import type { Directive } from 'vue'
import { http } from '@el-plus/utils/http'

// v-permisson:CGXQD:QXSP
export type Permission = `${string}:${string}`
export type HasPermission = Permission | boolean
const vPermisson: Directive<HTMLElement> & { name: string } = {
  name: 'permission',
  mounted(el, binding) {
    const { arg, value } = binding.value
    if (!arg && !value) {
      return
    }
    el.style.display = 'none'
    const permission: Permission = `${arg}:${value}`
    checkPermission(permission, el)
  },
  updated(el, binding) {
    const { arg, value } = binding.value
    if (!arg && !value) {
      if (el.style.display === 'none') {
        el.style.display = ''
      }
      return
    }
    const permission = `${arg}:${value}`
    checkPermission(permission, el)
  },
}

export async function checkPermission(permission: string, el: HTMLElement) {
  const { data: roles = [] } = await queryRoles()
  const hasPermission = roles.indexOf(permission) > -1
  if (!hasPermission) {
    el && el.parentNode && el.parentNode.removeChild(el)
  } else {
    el.style.display = ''
  }
  return hasPermission
}
type RequestPromise = Promise<{ data: string[] }>
let requestPromise: RequestPromise | null = null
async function queryRoles(): RequestPromise {
  try {
    if (requestPromise) {
      return requestPromise
    }
    requestPromise = http.post('/api-u/api/saas/user/appButtonRoleList', {
      loading: true,
    })
    return requestPromise
  } catch (error) {
    console.error(error)
    return { data: [] }
  }
}

export default vPermisson
